import { ButtonLink } from '@toggle/design-system';
import { useOutsideClick } from '@toggle/helpers/src/hooks/use-outside-click/useOutsideClick';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import poweredByToggleCompact from 'public/images/powered-by-toggle-compact.png';
import qrCode from 'public/images/qr-code.png';
import React, { useRef, useState } from 'react';

import { config } from '@/config/app.config';
import { useTouchDevice } from '@/stores/MediaQueryStore';
import { createLogGA } from '@/utils/analytics/logGA';
import { routes } from '@/utils/page-routes';

import * as S from './Footer.styles';

export const Footer = () => {
  const [showQR, setShowQR] = useState(false);
  const qrRef = useRef(null);
  const { t } = useTranslation('common');
  const isTouchDevice = useTouchDevice();
  const router = useRouter();
  useOutsideClick(qrRef, () => setShowQR(false));
  const handleDownloadClick = () => {
    const location =
      router.pathname === '/' ? 'landingPage' : 'assetPageHeader';
    createLogGA('Download')('click_download_app', { location });
    if (isTouchDevice) {
      router.push(routes.download);
    } else {
      setShowQR(true);
    }
  };

  return (
    <S.Container data-testid="footer">
      <S.Logotype>
        <a
          href={config.urls.website}
          title={t('common:goToMainWebsitePage')}
          target="_blank"
          rel="noreferrer"
        >
          <Image
            src={poweredByToggleCompact}
            alt={t('common:poweredByToggleAlt')}
            width="82"
            height="24"
          />
        </a>
      </S.Logotype>
      <S.NoticeMsg>
        <S.ExternalLink
          title={t('common:goToTermsAndConditionPage')}
          href={config.urls.termsAndCondition}
          target="_blank"
        >
          {t('common:noticeMsg')}
        </S.ExternalLink>
      </S.NoticeMsg>
      <S.ActionGroup>
        {showQR && (
          <S.QRContainer
            onClick={() => setShowQR(false)}
            data-testid="qr-container"
            ref={qrRef}
          >
            <Image src={qrCode} alt={t('common:qrAlt')} width={160} />
            <S.ScanText>{t('common:scanToDownload')}</S.ScanText>
          </S.QRContainer>
        )}
        <ButtonLink
          label={t('common:downloadApp')}
          onClick={handleDownloadClick}
        />
      </S.ActionGroup>
    </S.Container>
  );
};
